import { render, staticRenderFns } from "./About-mobile.vue?vue&type=template&id=26a95b46&scoped=true"
import script from "./About-mobile.vue?vue&type=script&lang=js"
export * from "./About-mobile.vue?vue&type=script&lang=js"
import style0 from "./About-mobile.vue?vue&type=style&index=0&id=26a95b46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a95b46",
  null
  
)

export default component.exports